import { useParams } from "../../useHistory";
import { useGlobalStore } from "../../providers/GlobalStore";

export const IdentityProviderSetUpRedirect: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const { passwordResetToken } = useParams<{ passwordResetToken: string }>();
  const globalStore = useGlobalStore();

  window.location.href = `https://${globalStore.config.idp.domain}/setup/${passwordResetToken}?brand=${globalStore.config.brand}`;

  return null;
};
